import { Menu, MenuItem, WithStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import InputLabel from '@material-ui/core/InputLabel';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import MenuIcon from '@material-ui/icons/Menu';
import { push } from 'connected-react-router';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import * as Actions from '../actions/imstat';
import MessageDialog from '../components/MessageDialog';
import ReactTable, {
	RowInfo,
	RowRenderProps,
} from '../components/MyReactTable';
import { IRootState } from '../reducers';
import i18n from '../resources/i18n';
import ImstatScenarioFactory, {
	IFetchTrainingProgressDataParam,
} from '../scenario/ImstatScenarioFactory';
import Config from '../site.config.json';
import { Routes, Screens } from '../utils/Routes';

const ITEM_HEIGHT = 48;

const styles = ({ spacing }: Theme) =>
	createStyles({
		innerButton: {
			fontSize: '0.625rem',
			marginLeft: spacing(1),
			marginRight: spacing(1),
			minWidth: 48,
		},
		link: {
			color: 'blue',
			cursor: 'pointer',
		},
		menuButton: {
			height: '32px',
			width: '32px',
		},
		pointer: {
			cursor: 'pointer',
		},
		rowBlue: {
			'&:hover': {
				backgroundColor: '#CEDDFF !important',
			},
			backgroundColor: '#D9E5Ff !important',
		},
		rowGray: {
			'&:hover': {
				backgroundColor: '#E5E5E5 !important',
			},
			backgroundColor: '#EEEEEE !important',
		},
		rowOrange: {
			'&:hover': {
				backgroundColor: '#FFEFBC !important',
			},
			backgroundColor: '#FFF4D1 !important',
		},
		rowPink: {
			'&:hover': {
				backgroundColor: '#FFD6DA !important',
			},
			backgroundColor: '#FFE1E4 !important',
		},
	});

/**
 * 通信教育タイプ
 */
export enum DistanceLearningTypes {
	ONGOING,
	RESULT,
}

interface IState {
	functionMenus?: JSX.Element;

	selectColumnsMenuAnchorEl?: HTMLElement;
	openErrorJukouMessageDialog: boolean;
	openErrorJukouStatusSinseiMessageDialog: boolean;
}

/**
 * 通信教育テーブル形式
 */
class ImstatDistanceLearningTable extends React.Component<IProps, IState> {
	constructor(props: IProps) {
		super(props);

		this.state = {
			openErrorJukouMessageDialog: false,
			openErrorJukouStatusSinseiMessageDialog: false,
		};
	}

	public render() {
		const { classes } = this.props;
		const columns = this.getSelectedColumns();

		return (
			<>
				<ReactTable
					data={this.props.data}
					columns={columns}
					defaultPageSize={5}
					className="-striped -highlight"
					getTrProps={this.setRowColor(classes)}
					columnsMenu={true}
					menuHandler={this.handleSelectColumns}
				/>
				{this.state.selectColumnsMenuAnchorEl &&
					this.getSelectColumnsMenu()}
				{this.state.functionMenus}
				<MessageDialog
					open={this.state.openErrorJukouMessageDialog}
					showCancelButton={false}
					title={i18n.t('ImstatDistanceLearningTable_0001')}
					contents={[{ content: 'LMCM_I_00634' }]}
					onClose={this.handleErrorMessageJukouDialogClose}
					onClickOk={this.handleErrorMessageJukouDialogClose}
				/>
				<MessageDialog
					open={this.state.openErrorJukouStatusSinseiMessageDialog}
					showCancelButton={false}
					title={i18n.t('ImstatDistanceLearningTable_0002')}
					contents={[{ content: 'LMCM_E_00677' }]}
					onClose={
						this.handleErrorMessageJukouStatusSinseiDialogClose
					}
					onClickOk={
						this.handleErrorMessageJukouStatusSinseiDialogClose
					}
				/>
			</>
		);
	}

	/**
	 * 全列情報取得
	 */
	protected getAllColumns(): any[] {
		const { classes } = this.props;
		if (this.props.type === DistanceLearningTypes.ONGOING) {
			return [
				{
					Cell: (row: RowRenderProps) => {
						return (
							<IconButton
								aria-label="More"
								aria-owns={
									this.state.functionMenus
										? 'long-menu'
										: undefined
								}
								aria-haspopup="true"
								data-index={row.index}
								onClick={this.handleOpenMenu}
								className={classes.menuButton}
								size="small"
							>
								<MenuIcon />
							</IconButton>
						);
					},
					accessor: 'function',
					required: true,
					show: false,
					sortable: false,
					width: 40,
				},
				{
					Header: i18n.t('ImstatDistanceLearningTable_0003'),
					accessor: 'compulsoryID',
					show: false,
					width: 80,
				},
				{
					Header: i18n.t('ImstatDistanceLearningTable_0004'),
					accessor: 'careerSubTitle',
					show: false,
				},
				{
					Cell: (row: RowRenderProps) => {
						return (
							<span
								className={this.props.classes.link}
								onClick={this.handleShowDetailDialog(
									row.original
								)}
							>
								{row.original.careerTitle}
							</span>
						);
					},
					Header: i18n.t('ImstatDistanceLearningTable_0005'),
					accessor: 'careerTitle',
					show: false,
					width: 300,
				},
				{
					Cell: (row: RowRenderProps) =>
						row.original.classID === 'CL000000'
							? i18n.t(row.value, { ns: 'force' })
							: row.value,
					Header: i18n.t('ImstatDistanceLearningTable_0006'),
					accessor: 'classTitle',
					show: false,
				},
				{
					Cell: (row: RowRenderProps) => {
						let period = row.value;
						if (period && period.indexOf('～') !== -1) {
							period = period.replace(
								'～',
								i18n.t('～', {
									ns: 'force',
								})
							);
						}
						return period;
					},
					Header: i18n.t('ImstatDistanceLearningTable_0007'),
					accessor: 'jissiKikan',
					show: false,
					width: 300,
				},
				{
					Header: i18n.t('ImstatDistanceLearningTable_0008'),
					accessor: 'cost',
					show: false,
				},
				{
					Cell: (row: RowRenderProps) => {
						let credit = row.value;
						if (credit !== null) {
							credit = credit.substring(0, credit.length - 2);
							return i18n.t('ImstatDistanceLearningTable_0041', {
								credit,
							});
						} else {
							return '';
						}
					},
					Header: i18n.t('ImstatDistanceLearningTable_0009'),
					accessor: 'credit',
					show: false,
				},
				{
					Header: i18n.t('ImstatDistanceLearningTable_0010'),
					accessor: 'target',
					show: false,
				},
				{
					Header: i18n.t('ImstatDistanceLearningTable_0011'),
					accessor: 'organizer',
					show: false,
				},
				{
					Cell: (row: RowRenderProps) => {
						let period = row.value;
						if (period && period.indexOf('～') !== -1) {
							period = period.replace(
								'～',
								i18n.t('～', {
									ns: 'force',
								})
							);
						}
						return period;
					},
					Header: i18n.t('ImstatDistanceLearningTable_0012'),
					accessor: 'mousikomiKikan',
					show: false,
				},
				{
					Cell: (row: RowRenderProps) => {
						const r = /^\d+\/(\d+)$/.exec(row.value);
						if (
							r &&
							parseInt(r[1], 10) !== 0 &&
							row.original.aplType !== '0'
						) {
							return (
								<>
									{row.value}
									<Button
										variant="contained"
										color="primary"
										size="small"
										onClick={this.handleShowExercise(
											row.original
										)}
										className={classes.innerButton}
									>
										{i18n.t(
											'ImstatDistanceLearningTable_0013'
										)}
									</Button>
								</>
							);
						}
						return <span>{row.value}</span>;
					},
					Header: i18n.t('ImstatDistanceLearningTable_0014'),
					accessor: 'kadai',
					show: false,
					width: 135,
				},
				{
					Cell: (row: RowRenderProps) => {
						const r = /^\d+\/(\d+)$/.exec(row.value);
						if (
							r &&
							parseInt(r[1], 10) !== 0 &&
							row.original.aplType !== '0'
						) {
							return (
								<>
									{row.value}
									<Button
										variant="contained"
										color="primary"
										size="small"
										onClick={this.showQuestionnaire(
											row.original
										)}
										className={classes.innerButton}
									>
										{i18n.t(
											'ImstatDistanceLearningTable_0015'
										)}
									</Button>
								</>
							);
						}
						return <span>{row.value}</span>;
					},
					Header: i18n.t('ImstatDistanceLearningTable_0016'),
					accessor: 'enquete',
					show: false,
					width: 130,
				},
				{
					Cell: (row: RowRenderProps) => {
						const targetAplTypes: string[] = [
							'0',
							'1',
							'2',
							'3',
							'4',
						];
						const status = i18n.t(row.value, { ns: 'force' });
						if (
							targetAplTypes.indexOf(row.original.aplType) !== -1
						) {
							return (
								// Todo リンク実装
								<span
									className={classes.link}
									onClick={this.handleShowApplicationStatus}
									data-index={row.index}
								>
									{status}
								</span>
							);
						}
						return <div>{status}</div>;
					},
					Header: i18n.t('ImstatDistanceLearningTable_0017'),
					accessor: 'status',
					show: false,
				},
			];
		} else {
			return [
				{
					Cell: (row: RowRenderProps) => {
						return (
							<IconButton
								aria-label="More"
								aria-owns={
									this.state.functionMenus
										? 'long-menu'
										: undefined
								}
								aria-haspopup="true"
								data-index={row.index}
								onClick={this.handleOpenMenu}
								className={classes.menuButton}
								size="small"
							>
								<MenuIcon />
							</IconButton>
						);
					},
					accessor: 'function',
					required: true,
					show: false,
					sortable: false,
					width: 40,
				},
				{
					Header: i18n.t('ImstatDistanceLearningTable_0018'),
					accessor: 'compulsoryID',
					show: false,
					width: 80,
				},
				{
					Header: i18n.t('ImstatDistanceLearningTable_0019'),
					accessor: 'careerSubTitle',
					show: false,
				},
				{
					Cell: (row: RowRenderProps) => {
						return (
							<span
								className={this.props.classes.link}
								onClick={this.handleShowDetailDialog(
									row.original
								)}
							>
								{row.original.careerTitle}
							</span>
						);
					},
					Header: i18n.t('ImstatDistanceLearningTable_0020'),
					accessor: 'careerTitle',
					show: false,
					width: 300,
				},
				{
					Cell: (row: RowRenderProps) =>
						row.original.classID === 'CL000000'
							? i18n.t(row.value, { ns: 'force' })
							: row.value,
					Header: i18n.t('ImstatDistanceLearningTable_0021'),
					accessor: 'classTitle',
					show: false,
				},
				{
					Cell: (row: RowRenderProps) => {
						let period = row.value;
						if (period && period.indexOf('～') !== -1) {
							period = period.replace(
								'～',
								i18n.t('～', {
									ns: 'force',
								})
							);
						}
						return period;
					},
					Header: i18n.t('ImstatDistanceLearningTable_0022'),
					accessor: 'jissiKikan',
					show: false,
					width: 300,
				},
				{
					Header: i18n.t('ImstatDistanceLearningTable_0023'),
					accessor: 'complDate',
					show: false,
					width: 300,
				},
				{
					Header: i18n.t('ImstatDistanceLearningTable_0024'),
					accessor: 'cost',
					show: false,
				},
				{
					Cell: (row: RowRenderProps) => {
						let credit = row.value;
						if (credit !== null) {
							credit = credit.substring(0, credit.length - 2);
							return i18n.t('ImstatDistanceLearningTable_0042', {
								credit,
							});
						} else {
							return '';
						}
					},
					Header: i18n.t('ImstatDistanceLearningTable_0025'),
					accessor: 'credit',
					show: false,
				},
				{
					Header: i18n.t('ImstatDistanceLearningTable_0026'),
					accessor: 'target',
					show: false,
				},
				{
					Header: i18n.t('ImstatDistanceLearningTable_0027'),
					accessor: 'organizer',
					show: false,
				},
				{
					Cell: (row: RowRenderProps) => {
						const r = /^\d+\/(\d+)$/.exec(row.value);
						if (
							r &&
							parseInt(r[1], 10) !== 0 &&
							row.original.aplType !== '0'
						) {
							return (
								<>
									{row.value}
									<Button
										variant="contained"
										color="primary"
										size="small"
										onClick={this.handleShowExercise(
											row.original
										)}
										className={classes.innerButton}
									>
										{i18n.t(
											'ImstatDistanceLearningTable_0028'
										)}
									</Button>
								</>
							);
						}
						return <span>{row.value}</span>;
					},
					Header: i18n.t('ImstatDistanceLearningTable_0029'),
					accessor: 'kadai',
					show: false,
				},
				{
					Cell: (row: RowRenderProps) => {
						const r = /^\d+\/(\d+)$/.exec(row.value);
						if (
							r &&
							parseInt(r[1], 10) !== 0 &&
							row.original.aplType !== '0'
						) {
							return (
								<>
									{row.value}
									<Button
										variant="contained"
										color="primary"
										size="small"
										onClick={this.showQuestionnaire(
											row.original
										)}
										className={classes.innerButton}
									>
										{i18n.t(
											'ImstatDistanceLearningTable_0030'
										)}
									</Button>
								</>
							);
						}
						return <span>{row.value}</span>;
					},
					Header: i18n.t('ImstatDistanceLearningTable_0031'),
					accessor: 'enquete',
					show: false,
				},
				{
					Cell: (row: RowRenderProps) => {
						const targetAplTypes: string[] = [
							'0',
							'1',
							'2',
							'3',
							'4',
						];
						const status = i18n.t(row.value, { ns: 'force' });
						if (
							targetAplTypes.indexOf(row.original.aplType) !== -1
						) {
							return (
								<span
									className={classes.link}
									onClick={this.handleShowApplicationStatus}
									data-index={row.index}
								>
									{status}
								</span>
							);
						}
						return <div>{status}</div>;
					},
					Header: i18n.t('ImstatDistanceLearningTable_0032'),
					accessor: 'status',
					show: false,
				},
			];
		}
	}

	/**
	 * 選択中列情報取得
	 */
	protected getSelectedColumns() {
		const columns: any[] = Object.assign([], this.getAllColumns());

		columns.map((column: any) => {
			if (column.required) {
				column.show = true;
			} else {
				column.show = false;
			}
		});

		this.props.selectedColumns.map((index: number) => {
			columns[index].show = true;
		});

		return columns;
	}

	/**
	 * 列選択メニュー取得
	 */
	protected getSelectColumnsMenu() {
		const { classes } = this.props;
		const allColumns = this.getAllColumns();
		const checkboxList: any[] = [];

		allColumns.map((column: any, index: number) => {
			if (!column.required) {
				checkboxList.push({
					checked: this.props.selectedColumns.indexOf(index) !== -1,
					index,
					text: column.Header,
				});
			}
		}, this);

		return (
			<Menu
				id="logout-menu"
				anchorEl={this.state.selectColumnsMenuAnchorEl}
				open={this.state.selectColumnsMenuAnchorEl ? true : false}
				onClose={this.handleCloseSelectColumns}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
				transformOrigin={{ vertical: 'top', horizontal: 'center' }}
				getContentAnchorEl={undefined}
			>
				{checkboxList.map((checkboxItem, i) => {
					return (
						<MenuItem key={i}>
							<Checkbox
								id={checkboxItem.text}
								onChange={this.handleChangeCheckBox(
									checkboxItem
								)}
								checked={checkboxItem.checked}
							/>
							<InputLabel
								className={classes.pointer}
								htmlFor={checkboxItem.text}
							>
								{checkboxItem.text}
							</InputLabel>
						</MenuItem>
					);
				})}
			</Menu>
		);
	}

	/**
	 * 行メニュー表示
	 * @param functionMenuAnchorEl アンカー要素
	 * @param rowData 対象行情報
	 */
	protected getFunctionMenus(
		functionMenuAnchorEl: HTMLElement,
		rowData:
			| Actions.IOnGoingDistanceLearning
			| Actions.IResultDistanceLearning
	) {
		let rowOnGoing: Actions.IOnGoingDistanceLearning | null = null;
		let rowResult: Actions.IResultDistanceLearning | null = null;
		if (this.props.type === DistanceLearningTypes.ONGOING) {
			rowOnGoing = rowData as Actions.IOnGoingDistanceLearning;
		} else {
			rowResult = rowData as Actions.IResultDistanceLearning;
		}

		return (
			<Menu
				anchorEl={functionMenuAnchorEl}
				open={true}
				onClose={this.handleCloseMenu}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
				transformOrigin={{ vertical: 'top', horizontal: 'center' }}
				getContentAnchorEl={undefined}
				PaperProps={{
					style: {
						maxHeight: ITEM_HEIGHT * 4.5,
						width: 200,
					},
				}}
			>
				<MenuItem onClick={this.handleShowDetail(rowData)}>
					{i18n.t('ImstatDistanceLearningTable_0033')}
				</MenuItem>
				{rowOnGoing && rowOnGoing.appChangeOkFlg && (
					<MenuItem
						onClick={this.handleShowChangeApplication(rowOnGoing)}
					>
						{i18n.t('ImstatDistanceLearningTable_0034')}
					</MenuItem>
				)}
				{rowOnGoing && rowOnGoing.appResultOkFlg && (
					<MenuItem
						onClick={this.handleShowActResultApplication(
							rowOnGoing
						)}
					>
						{i18n.t('ImstatDistanceLearningTable_0035')}
					</MenuItem>
				)}
				{rowOnGoing && rowOnGoing.lecCancelOkFlg && (
					<MenuItem onClick={this.handleShowStCancel(rowOnGoing)}>
						{i18n.t('ImstatDistanceLearningTable_0036')}
					</MenuItem>
				)}
				{rowOnGoing && rowOnGoing.appCancelOkFlg && (
					<MenuItem
						onClick={this.handleShowCancelApplication(rowOnGoing)}
					>
						{i18n.t('ImstatDistanceLearningTable_0037')}
					</MenuItem>
				)}
				{rowResult && rowResult.referenceOkFlg && (
					<MenuItem
						onClick={this.handleShowActResultReference(rowResult)}
					>
						{i18n.t('ImstatDistanceLearningTable_0038')}
					</MenuItem>
				)}
				{rowResult && rowResult.certificateDispFlg && (
					<MenuItem
						onClick={this.handleShowComplCertificate(rowResult)}
					>
						{i18n.t('ImstatDistanceLearningTable_0039')}
					</MenuItem>
				)}
				{rowResult && rowResult.retakeOkFlg && (
					<MenuItem onClick={this.handleShowApply(rowResult)}>
						{i18n.t('ImstatDistanceLearningTable_0040')}
					</MenuItem>
				)}
			</Menu>
		);
	}

	/**
	 * 行カラー設定
	 */
	protected setRowColor = (classes: Record<string, string>) => (
		state: any,
		rowInfo: RowInfo
	) => {
		if (rowInfo === undefined) {
			return {};
		}
		let className: string = '';
		if (rowInfo.original.compulsoryCssClass === 'row_color_pink') {
			className = classes.rowPink;
		} else if (rowInfo.original.compulsoryCssClass === 'row_color_orange') {
			className = classes.rowOrange;
		} else if (rowInfo.original.compulsoryCssClass === 'row_color_blue') {
			className = classes.rowBlue;
		} else if (rowInfo.original.compulsoryCssClass === 'row_color_gray') {
			className = classes.rowGray;
		}

		return {
			className,
		};
	};

	/**
	 * メニューオープンハンドラ
	 */
	protected handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
		const index = event.currentTarget.getAttribute('data-index');
		if (index && index !== '') {
			if (this.props.type === DistanceLearningTypes.ONGOING) {
				const rowData: Actions.IOnGoingDistanceLearning = this.props
					.data[index];
				const functionMenus = this.getFunctionMenus(
					event.currentTarget,
					rowData
				);
				this.setState({ functionMenus });
			} else if (this.props.type === DistanceLearningTypes.RESULT) {
				const rowData: Actions.IResultDistanceLearning = this.props
					.data[index];
				const functionMenus = this.getFunctionMenus(
					event.currentTarget,
					rowData
				);
				this.setState({ functionMenus });
			}
		}
	};

	/**
	 * 列選択メニューハンドラ
	 */
	protected handleSelectColumns = (event: React.MouseEvent<HTMLElement>) => {
		this.setState({
			selectColumnsMenuAnchorEl: event.currentTarget,
		});
	};

	/**
	 * 列選択メニュークローズハンドラ
	 */
	protected handleCloseSelectColumns = () => {
		this.setState({
			selectColumnsMenuAnchorEl: undefined,
		});
	};

	/**
	 * チェックボックス変更ハンドラ
	 */
	protected handleChangeCheckBox = (checkboxItem: any) => (
		event: React.ChangeEvent<HTMLInputElement>
	) => {
		const newSelectedColumns = Object.assign(
			[],
			this.props.selectedColumns
		);
		const idx = newSelectedColumns.indexOf(checkboxItem.index);

		if (event.target.checked) {
			if (idx === -1) {
				newSelectedColumns.push(checkboxItem.index);
			}
		} else {
			if (idx !== -1) {
				newSelectedColumns.splice(idx, 1);
			}
		}

		if (this.props.type === DistanceLearningTypes.ONGOING) {
			this.props.setOnGoingSelectedColumns(newSelectedColumns);
		} else if (this.props.type === DistanceLearningTypes.RESULT) {
			this.props.setResultSelectedColumns(newSelectedColumns);
		}
	};

	/**
	 * メニュークローズハンドラ
	 */
	protected handleCloseMenu = (event: React.MouseEvent<HTMLElement>) => {
		this.setState({ functionMenus: undefined });
	};
	/**
	 * 受講ボタンエラーメッセージクローズ
	 */
	protected handleErrorMessageJukouDialogClose = () => {
		this.setState({ openErrorJukouMessageDialog: false });
	};
	/**
	 * 受講申請中受講ボタンエラーメッセージクローズ
	 */
	protected handleErrorMessageJukouStatusSinseiDialogClose = () => {
		this.setState({ openErrorJukouStatusSinseiMessageDialog: false });
	};

	/**
	 * 詳細画面表示
	 * @param e イベントオブジェクト
	 */
	protected handleShowDetail = (rowData: Actions.IDistanceLearning) => (
		e: React.MouseEvent<HTMLElement>
	) => {
		let to = Routes.getPath(Screens.PERSONAL_CAREER_DETAIL);
		to = to.replace(/\/:career_id/, `/${rowData.careerID}`);
		this.props.pushHistory(to);
		this.setState({ functionMenus: undefined });
	};

	protected handleShowDetailDialog = (rowData: Actions.IELearning) => (
		e: React.MouseEvent<HTMLElement>
	) => {
		const careerDetailDialog: Actions.ICareerDetailDialog = {
			apllType: '',
			careerID: rowData.careerID,
			classID: '',
			curriculumFlg: '0',
			setApplicationStatusDialog: false,
			setOpenCareerDetailDialog: true,
			setOpenCurriculumDetailDialog: false,
		};
		this.props.setCareerDetailDialog(careerDetailDialog);
	};

	/**
	 * 申請変更画面表示
	 * @param e イベントオブジェクト
	 */
	protected handleShowChangeApplication = (
		rowData: Actions.IOnGoingDistanceLearning
	) => (e: React.MouseEvent<HTMLElement>) => {
		const { careerID, classID } = rowData;

		let to = Routes.getPath(Screens.PERSONAL_APPLICATION_CHANGE);
		to = to.replace(/\/:career_id/, `/${careerID}`);
		to = to.replace(/\/:class_id/, `/${classID}`);
		this.props.pushHistoryState(to, { caller: window.location.pathname });
		this.setState({ functionMenus: undefined });
	};

	/**
	 * 実績申請画面表示
	 * @param e イベントオブジェクト
	 */
	protected handleShowActResultApplication = (
		rowData: Actions.IOnGoingDistanceLearning
	) => (e: React.MouseEvent<HTMLElement>) => {
		const { careerID, classID } = rowData;
		let to = Routes.getPath(Screens.PERSONAL_ACT_RESULT_APPLICATION);
		to = to.replace(/\/:career_id/, `/${careerID}`);
		to = to.replace(/\/:class_id/, `/${classID}`);
		to = to.replace(/\/:nittei_only_flg/, `/0`);
		this.props.pushHistoryState(to, { caller: window.location.pathname });
		this.setState({ functionMenus: undefined });
	};
	/**
	 * 受講取消画面表示
	 * @param e イベントオブジェクト
	 */
	protected handleShowStCancel = (
		rowData: Actions.IOnGoingDistanceLearning
	) => (e: React.MouseEvent<HTMLElement>) => {
		const { careerID, classID } = rowData;
		let to = Routes.getPath(Screens.PERSONAL_LECTURE_CANCEL);
		to = to.replace(/\/:career_id/, `/${careerID}`);
		to = to.replace(/\/:class_id/, `/${classID}`);
		to = to.replace(/\/:curriculum_flg/, `/0`);
		this.props.pushHistoryState(to, { caller: window.location.pathname });
		this.setState({ functionMenus: undefined });
	};
	/**
	 * 申請取消画面表示
	 * @param e イベントオブジェクト
	 */
	protected handleShowCancelApplication = (
		rowData: Actions.IOnGoingDistanceLearning
	) => (e: React.MouseEvent<HTMLElement>) => {
		const { aplType, careerID, classID } = rowData;

		let to = Routes.getPath(Screens.PERSONAL_APPLICATION_CANCEL);
		to = to.replace(/\/:career_id/, `/${careerID}`);
		to = to.replace(/\/:class_id/, `/${classID}`);
		to = to.replace(/\/:apl_type/, `/${aplType}`);
		this.props.pushHistoryState(to, { caller: window.location.pathname });
		this.setState({ functionMenus: undefined });
	};
	/**
	 * 課題提出画面表示
	 * @param e イベントオブジェクト
	 */
	protected handleShowExercise = (rowData: Actions.IDistanceLearning) => (
		e: React.MouseEvent<HTMLElement>
	) => {
		const { careerID, classID } = rowData;
		let to = Routes.getPath(Screens.PERSONAL_EXERCISE);
		to = to.replace(/\/:career_id\//, `/${careerID}/`);
		to = to.replace(/\/:class_id/, `/${classID}`);
		this.props.pushHistoryState(to, { caller: window.location.pathname });
	};

	/**
	 * アンケート一覧画面表示
	 * @param e イベントオブジェクト
	 */
	protected showQuestionnaire = (rowData: Actions.IDistanceLearning) => (
		e: React.MouseEvent<HTMLElement>
	) => {
		const { careerID, classID } = rowData;
		let pathname = Routes.getPath(Screens.PERSONAL_QUESTIONNAIRE);
		pathname = pathname.replace(/\/:career_id\//, `/${careerID}/`);
		pathname = pathname.replace(/\/:class_id/, `/${classID}`);
		this.props.pushHistoryState(pathname, {
			caller: window.location.pathname,
		});
	};

	/**
	 * 申請内容画面表示
	 * @param e イベントオブジェクト
	 */
	protected handleShowApplicationStatus = (
		e: React.MouseEvent<HTMLElement>
	) => {
		const index = e.currentTarget.getAttribute('data-index');
		if (index && index !== '') {
			const rowData: Actions.IELearning = this.props.data[index];
			const { careerID, classID, aplType } = rowData;
			const careerDetailDialog: Actions.ICareerDetailDialog = {
				apllType: aplType,
				careerID,
				classID,
				curriculumFlg: '0',
				setApplicationStatusDialog: true,
				setOpenCareerDetailDialog: false,
				setOpenCurriculumDetailDialog: false,
			};
			this.props.setCareerDetailDialog(careerDetailDialog);
		}
	};

	/**
	 * 実績参照画面表示
	 * @param e イベントオブジェクト
	 */
	protected handleShowActResultReference = (
		rowData: Actions.IResultDistanceLearning
	) => (e: React.MouseEvent<HTMLElement>) => {
		const {
			careerID,
			classID,
			seq,
			imstatListStatusId,
			reasonCode,
		} = rowData;
		let to = Routes.getPath(Screens.PERSONAL_ACT_RESULT_REFERENCE);
		to = to.replace(/\/:career_id/, `/${careerID}`);
		to = to.replace(/\/:class_id/, `/${classID}`);
		to = to.replace(/\/:seq/, `/${seq}`);
		const state = {
			careerID,
			classID,
			imstatListStatusId,
			reasonCode,
			seq,
		};
		this.props.pushHistoryState(to, state);
		this.setState({ functionMenus: undefined });
	};

	/**
	 * 再申請画面表示
	 * @param e イベントオブジェクト
	 */
	protected handleShowApply = (rowData: Actions.IResultDistanceLearning) => (
		e: React.MouseEvent<HTMLElement>
	) => {
		const { careerID } = rowData;
		const to = Routes.getPath(Screens.PERSONAL_LECTURE_APPLICATION);
		const state = {
			caller: window.location.pathname,
			careerType: '0',
			targetCareerId: careerID,
		};
		this.props.pushHistoryState(to, state);
		this.setState({ functionMenus: undefined });
	};

	/**
	 * 修了証明書表示
	 * @param e イベントオブジェクト
	 */
	protected handleShowComplCertificate = (
		rowData: Actions.IResultDistanceLearning
	) => (e: React.MouseEvent<HTMLElement>) => {
		const { careerID } = rowData;
		const { userAttr } = this.props;

		let url = Config.tsqPath + '/tsq/pkg/action/per/certificate.action?';
		url = url + 'userId=' + userAttr.userId;
		url = url + '&locale=' + userAttr.locale;
		url = url + '&lang=' + userAttr.lang;
		url = url + '&careerID=' + careerID;
		url = url + '&accessType=10';
		window.open(url, '_blank');
		this.setState({ functionMenus: undefined });
	};
}

const mapStateToProps = (state: IRootState) => ({
	token: state.session.token,
	userAttr: state.session.userAttr,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	fetchTrainingProgressData: (
		token: string,
		arg: IFetchTrainingProgressDataParam
	) => {
		const s = ImstatScenarioFactory.createFetchTrainingProgressData(
			dispatch,
			token
		);
		s.run(arg);
	},
	pushHistory: (path: string) => dispatch(push(path)),
	pushHistoryState: (path: string, state: any) =>
		dispatch(
			push({
				pathname: path,
				state,
			})
		),
	setOnGoingSelectedColumns: (selectedColumns: number[]) =>
		dispatch(
			Actions.setImstatOnGoingDistanceLearningSelectedColumns({
				selectedColumns,
			})
		),
	setResultSelectedColumns: (selectedColumns: number[]) =>
		dispatch(
			Actions.setImstatResultDistanceLearningSelectedColumns({
				selectedColumns,
			})
		),

	setCareerDetailDialog: (CareerDetailDialog: Actions.ICareerDetailDialog) =>
		dispatch(Actions.setCareerDetailDialog({ CareerDetailDialog })),
});

export interface IImstatDistanceLearningTableProps {
	data:
		| Actions.IOnGoingDistanceLearning[]
		| Actions.IResultDistanceLearning[];
	selectedColumns: number[];
	type: DistanceLearningTypes;
}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> & IImstatDistanceLearningTableProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(ImstatDistanceLearningTable);

const Styled = withStyles(styles)(Connected);

export default Styled;



// WEBPACK FOOTER //
// ./src/containers/ImstatDistanceLearningTable.tsx